import {
  Lesson,
  InstrumentType,
  LessonType,
  ActivityType,
} from '@fenderdigital/api-definitions/play';

export interface MarkLessonCompletePayload {
  completed: boolean;
  instrument: InstrumentType;
  'lesson-id': string;
  'lesson-type': LessonType;
  'activity-type': ActivityType;
}

function getLessonsPayload(lessons: Lesson[], completed: boolean): MarkLessonCompletePayload[] {
  if (!lessons?.length) return [];
  return lessons.map(lesson => {
    const { id, instrument, type, 'activity-type': activityType } = lesson || {};
    return {
      completed,
      videoWatchedPercentage: completed ? 100 : 0,
      instrument,
      'lesson-id': id,
      'lesson-type': type,
      'activity-type': activityType || 'lesson',
    };
  });
}

// eslint-disable-next-line import/prefer-default-export
export { getLessonsPayload };
